import Vue from 'vue'
import Vuex from 'vuex'
import messages from './modules/messages'
import candidates from './modules/candidates'
import cart from './modules/cart'
import articles from './modules/blog'
import publications from './modules/publications'

Vue.use(Vuex)

const updateLocalStorage = store => {
  // called when the store is initialized
  store.subscribe((mutation, state) => {
    // called after every mutation.
    // The mutation comes in the format of `{ type, payload }`.
    localStorage.setItem('store', JSON.stringify(state));
  })
}
const updateCart = store => {
    store.subscribe((mutation, state) => {
    localStorage.setItem('cart', JSON.stringify(state.cart));
  })
}

export default new Vuex.Store({
  modules: {
    messages,
    candidates,
    cart,
    articles,
    publications
  },
  plugins: [
    updateLocalStorage,
    updateCart
  ]
})
